export * from "./getSingleFlavorConsumable";
